import { render, staticRenderFns } from "./workChange.vue?vue&type=template&id=e27bd9c8&scoped=true&"
import script from "./workChange.vue?vue&type=script&lang=js&"
export * from "./workChange.vue?vue&type=script&lang=js&"
import style0 from "./workChange.vue?vue&type=style&index=0&id=e27bd9c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27bd9c8",
  null
  
)

export default component.exports